import { useConfigService } from '@thd-nucleus/experience-context';
import { JOBSITE_HOURS_HIDE_SWITCH } from '../components/constants';

/**
 * Whether the Jobsite Hours fields should render.
 * Hidden only when the feature switch is on AND the host reports a managed account.
 * A missing or false `managedFlag` (data not loaded, field absent, non-managed) shows the fields.
 *
 * @param {boolean} [managedFlag] `requestedBy.managedFlag` from the host's `projects` / `projectDetails` data
 */
export const useShowJobsiteHours = (managedFlag) => {
  const switchOn = useConfigService(JOBSITE_HOURS_HIDE_SWITCH);
  return !(switchOn && !!managedFlag);
};
